"use client";

import clsx from "clsx";
import Container from "~/components/Container";
import HoverArrowLink from "~/components/HoverArrowLink";
import CustomImage from "~/components/CustomImage";
import CustomLink from "~/components/CustomLink";
import { type ImageTextBlockHero_Fields } from "~/__generated__/graphql";
import { usePathname } from "next/navigation";

export default function ImageTextBlockHero({
  image,
  title,
  parentPage,
}: ImageTextBlockHero_Fields) {
  const pathname = usePathname();

  return (
    <section
      className={clsx(
        "relative",
        image?.node.sourceUrl && "with-image",
        !image?.node.sourceUrl && "min-h-[10rem] bg-black",
      )}
    >
      <CustomImage
        data={image}
        priority
        loadingType="eager"
        className="w-full bg-black object-cover sm:aspect-1.75/1 md:aspect-2.75/1 xl:aspect-3.25/1"
        sizes="100vw"
      />
      <Container containerClass="relative z-20 bg-black bottom-0 left-0 sm:left-1/2 w-full grid sm:-translate-x-1/2 mx-auto sm:bg-transparent sm:grid-cols-4 sm:gap-4 sm:absolute sm:-translate-y-4 md:gap-8 md:grid-cols-8 md:-translate-y-8 lg:grid-cols-12 xl:-translate-y-12">
        <div className="grid w-full gap-4 bg-black py-4 sm:col-span-3 sm:px-8 md:col-span-6 md:py-8 lg:col-span-8 lg:grid-cols-8 lg:px-0 xl:col-span-6 xl:grid-cols-6 xl:py-12">
          {/* Back button */}
          <CustomLink
            to={pathname?.split("/").slice(0, -1).join("/") + "/"}
            className="group flex items-center text-white opacity-60 hover:opacity-100 lg:col-span-6 lg:col-start-2 xl:col-span-3 xl:col-start-2"
          >
            <>
              <HoverArrowLink
                arrowClass="stroke-white"
                className="mr-2 w-5"
                direction="left"
              />
              {parentPage}
            </>
          </CustomLink>
          {/* Title */}
          {title && (
            <h1 className="text-heading-4 text-white lg:col-span-6 lg:col-start-2 xl:col-span-3 xl:col-span-4 xl:col-start-2">
              {title}
            </h1>
          )}
        </div>
      </Container>
    </section>
  );
}
